export default {
    data() {
        return {
            cleanup_cookies: [
                'bs_token',
                'bs_token_valid_until',
                'bs_customer_id',
                'bs_departments',
                'bs_language',
                'bs_name',
                'bs_profile',
                'bs_role',
                'bs_user_id',
                'bs_username',
                'bs_active_department_id'
            ],
        }
    },

    methods: {
        clearCookies() {
            
        },

        setCookies(cookies) {
            let domain = process.env.VUE_APP_ENV === 'production' ? process.env.VUE_APP_WRAPPER_COOKIE_DOMAIN : null;

            return new Promise(resolve => {
                cookies.forEach(cookie => {
                    this.$cookies.set(cookie.key, cookie.value, null, '/', domain);
                });

                resolve(true);
            });
        }
    }
}